module.exports = __webpack_public_path__ + "img/list.bc0f3c2c.png";